var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.177 3.237a.25.25 0 0 0-.354 0l-7.146 7.146-.646 2.586 2.586-.646 7.146-7.146a.25.25 0 0 0 0-.354l-1.586-1.586zm-1.414-1.06a1.75 1.75 0 0 1 2.475 0l1.585 1.586a1.75 1.75 0 0 1 0 2.474L6.53 13.53a.75.75 0 0 1-.348.198l-4 1a.75.75 0 0 1-.91-.91l1-4a.75.75 0 0 1 .198-.348l7.293-7.293z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export default ForwardRef;